module.exports = __webpack_public_path__ + "static/media/icon_2.5b9d2d78.png";